import { render, staticRenderFns } from "./SetMenu.vue?vue&type=template&id=588a4b2e&scoped=true"
import script from "./SetMenu.vue?vue&type=script&lang=js"
export * from "./SetMenu.vue?vue&type=script&lang=js"
import style0 from "./SetMenu.vue?vue&type=style&index=0&id=588a4b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588a4b2e",
  null
  
)

export default component.exports